import { Overlay } from "../Overlay";
import React, { useEffect, useRef, useState } from "react";

export type DrawerProps = {
	children?: React.ReactNode
	backdrop?: boolean
	visible?: boolean
	width?: number
	title?: string
	closeDuration?: number
	onClose?: () => void
	onCloseClick?: () => void
}

export const Drawer: React.FC<DrawerProps> = (props) => {
	const { children, visible, backdrop, width, title, closeDuration = 300, onClose, onCloseClick } = props
	const [drawerVisible, setDrawerVisible] = useState(visible)
	const drawerRef = useRef<HTMLDivElement | null>(null)

	useEffect(() => {
		setDrawerVisible(visible)
		if (!drawerRef.current) return;

		setTimeout(() => {
			drawerRef.current?.classList.remove('translate-x-full');
		}, 50)
	}, [visible])

	const onBackgroundClick = () => {
		drawerRef.current?.classList.add('translate-x-full');

		setDrawerVisible(false)
		setTimeout(() => {
			onClose?.()
		}, closeDuration)
	}
	return <>
		{visible && (
			<Overlay backdrop={backdrop} onBackgroundClick={onBackgroundClick}>
				<div
					className={`h-full bg-white p-2 pointer-events-auto md:w-80 ml-auto transform translate-x-full transition transition-duration-${closeDuration}` + (width ? '' : ' w-full')}
					style={{ ...(width ? { width } : {}) }}
					ref={drawerRef}
				>
					<div className="flex text-lg">
						<div className="cursor-pointer" onClick={() => {
							drawerRef.current?.classList.add('translate-x-full');

							setTimeout(() => {
								onCloseClick?.()
								onClose?.()
							}, closeDuration)
						}}
						>
							<i className="fas fa-times"></i>
						</div>
						<div>
							{title}
						</div>
					</div>
					{children}
				</div>
			</Overlay>
		)}
	</>
}